import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BlogHeaderProps {
  showBackButton?: boolean;
}

export const BlogHeader = ({ showBackButton = false }: BlogHeaderProps) => {
  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur-md border-b border-border/50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <Link
              to="/blog"
              className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Back to Blog</span>
            </Link>
          )}
          {!showBackButton && (
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="DiskOver" className="h-8 w-8" />
              <span className="text-xl font-bold text-primary">DiskOver Blog</span>
            </Link>
          )}
        </div>

        <Link
          to="/"
          className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
        >
          Explore App →
        </Link>
      </div>
    </header>
  );
};
